module.exports = __webpack_public_path__ + "static/assets/ae4fdf588b063e05cd99593e785dd60d.jpg";